import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-6 md:px-12 py-24 text-center">
      <span className="font-script text-4xl text-blush-600">a soft detour</span>
      <h1 className="font-heading text-5xl md:text-6xl text-ink-900 mt-2">404</h1>
      <p className="mt-4 font-body text-ink-700">
        The page you're looking for seems to have drifted away on a breeze.
      </p>
      <Link to="/" className="btn-maroon mt-8 inline-block">
        Return home
      </Link>
    </div>
  );
}
